module.exports = __webpack_public_path__ + "img/sld_step_down_transformer_h_r1_l1_disable.86e9e887.svg";